<div class="container-fluid footer-wrapper d-flex justify-content-between align-items-center">
  <div>
    <strong>Ars Ultima</strong>&nbsp;v{{ versionNumber }} ©2020-2024 /
    {{ 'footer.baseline' | transloco }}
  </div>
</div>
